export const ISSUE_FIELD_CODE = 'code';
export const ISSUE_FIELD_TITLE = 'title';
export const ISSUE_FIELD_ISSUE_TYPE = 'issueType';
export const ISSUE_FIELD_ISSUE_SUBTYPE = 'issueSubtype';
export const ISSUE_FIELD_SOURCE_APP = 'sourceApplication';
export const ISSUE_FIELD_ENTITY_NAME = 'sourceEntityName';
export const ISSUE_FIELD_SEVERITY = 'severity';
export const ISSUE_FIELD_CREATED = 'createdAt';
export const ISSUE_FIELD_UPDATED = 'updatedAt';
export const ISSUE_FIELD_OWNER = 'owner';
export const ISSUE_FIELD_ISSUE_STATUS = 'status';
export const ISSUE_FIELD_ACTION_STATUS = 'actionStatus';
export const ISSUE_FIELD_CREATOR = 'creator';
export const ISSUE_FIELD_MANAGER = 'manager';
export const ISSUE_FIELD_APPROVER = 'approver';
export const ISSUE_FIELD_DUE_DATE = 'dueDate';
export const ISSUE_FIELD_ACTUAL_REMEDIATION_DATE = 'actualRemediationDate';
export const ISSUE_FIELD_ACTION_DUE_DATE = 'actionDueDate';
export const ISSUE_FIELD_ACTION_CREATED = 'actionCreatedAt';
export const ISSUE_FIELD_ACTION_UPDATED = 'actionUpdatedAt';
export const ISSUE_FIELD_SLA_DUE_DAYS = 'slaDueDays';
export const ISSUE_FIELD_ACTION_COUNT = 'actionCount';
export const ISSUE_FIELD_ACTION_PROGRESS = 'actionProgress';
export const ISSUE_FIELD_ACTION_OWNER = 'actionOwner';
export const ISSUE_FIELD_ACTION_APPROVER = 'actionApprover';
export const ISSUE_FIELD_ACTION_TITLE = 'actionTitle';
export const ISSUE_FIELD_SLA_STATUS = 'slaStatus';

export type IssueColumnVisibilityName =
  | 'issueType'
  | 'owner'
  | 'status'
  | 'creator'
  | 'approver'
  | 'dueDate'
  | 'slaDueDays'
  | 'actionProgress';
